export type ContentPropsT = {
	handleFilterSubmit: (submittedFilters: any) => void;
	onClose: () => void;
};

export const FORM_FIELD_KEYS = {
	NAME: 'name'
};
